import React, {Component} from 'react';
import logo from './jobrank-logo.png';
import './App.css';
import './extensions/string'
import FadingMessage from './components/FadingMessage'
import {registerAccount} from './services/AccountService.js'

class App extends Component {

	constructor(props) {
		super(props);
		this.state = {email: "", message: undefined, registerDisabled: false};
	}

	render() {
		return (
			<div className="landing">
				<header className="landing-header">
					<img src={logo} className="landing-logo" alt="JobRank Logo"/>
				</header>
				<p className="landing-intro">
					Want to hear more? Register your email address. We’ll be in touch.
				</p>
				<FadingMessage message={this.state.message}/>
				<input type="email" size="40" placeholder="my.email@example.com"
					   value={this.state.email}
					   onChange={this.emailChanged} onKeyPress={this.keyPressed}/>
				<button onClick={this.buttonPressed} disabled={this.state.registerDisabled}>Register</button>
			</div>
		);
	}

	buttonPressed = async (event) => {
		return this.register();
	};

	keyPressed = async (event) => {
		if (event.key === 'Enter')
			return this.register();
	};

	emailChanged = (event) => {
		const email = event.target.value;
		this.setState({email});
	};

	register = async () => {
		const email = this.state.email;
		console.log( `Attempting to register with email '${email}'`);
		if (email.isEmpty()) {
			console.log("Email is empty, displaying failure message.");
			this.showFailure("You must specify an email before attempting to register.");
			return;
		} else {
			console.log( "Email is not empty, continuing." );
		}

		this.setState({registerDisabled: true});
		try {
			const location = await registerAccount(email);
			this.showSuccess("Registration successful. ✅", "success");
			this.setState({email: ""});
			console.log(`Account created at location: ${location}`);
		} catch( error ) {
			if( error.reason === "invalid" ) {
				if (error.errorCodes.includes("email.invalid")) {
					this.showFailure("Not a valid email address.");
				} else if (error.errorCodes.includes("email.registered")) {
					this.showSuccess("Registration successful. 🔁");
				} else {
					this.showFailure( "Account creation invalid. 💥" );
				}
			} else {
				this.showFailure( "Could not register account." );
				console.error( error )
				console.error( `Account creation failed for unknown cause: ${error}` )
			}
		} finally {
			this.setState({registerDisabled: false});
		}
	};

	showSuccess = (text) => this.showMessage(text, "success");
	showFailure = (text) => this.showMessage(text, "failure");

	showMessage = (text, type) => {
		console.log(`Showing message (${type}): ${text}`);
		const message = { text, type };
		this.setState({message})
	};
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js